import { Base64 } from "base64-string";
import { IDecryptedKeys } from "./decryptKeys";
import * as openpgp from "openpgp";

export const setKeys = (
  userId: string,
  keys: IDecryptedKeys,
  intermediatePublicKey: openpgp.key.Key,
  recoveryKey: string,
) => {
  const enc = new Base64();
  const serializedKeys = enc.encode(JSON.stringify(keys));

  localStorage.setItem(`${userId}.keys`, serializedKeys);

  const options: openpgp.EncryptOptions = {
    message: openpgp.message.fromText(recoveryKey),
    publicKeys: [intermediatePublicKey],
  };

  openpgp
    .encrypt(options)
    .then((ciphertext) => {
      return btoa(ciphertext.data);
    })
    .then(async (r) => {
      localStorage.setItem(`${userId}.recov`, r);
    });
};
